import React from 'react';
import { Spinner } from 'ui/index';

const UploaderLoader = () => (
  <div className="mt-16 ta-c" data-testid="loadingSpinner">
    <Spinner />
  </div>
);

export { UploaderLoader };
